export default "__VITE_ASSET__qzfkPzbX__"